import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "hint" }
const _hoisted_2 = { class: "pre" }
const _hoisted_3 = { class: "post" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("span", _hoisted_2, _toDisplayString($props.pre), 1 /* TEXT */),
    _cache[0] || (_cache[0] = _createTextVNode(" " + _toDisplayString(' ') + " ")),
    _createElementVNode("span", _hoisted_3, _toDisplayString($props.post), 1 /* TEXT */)
  ]))
}